import React from 'react';
const CallToAction = () => {
  return <section className="w-full py-16 px-6 md:px-12 lg:px-24 bg-[#C17A47]" data-id="element-30">
      <div className="max-w-4xl mx-auto text-center" data-id="element-31">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-32">
          Es hora de soltar la culpa. Es hora de recuperar tu paz en la cocina.
        </h2>
        <div className="flex justify-center mb-12" data-id="element-33">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hvyc6wGYK86hgJ6EuTfUGA/ChatGPT_Image_Sep_11%2C_2025%2C_04_46_41_PM.png" alt="Ebook de recetas" className="w-full max-w-xs rounded-lg shadow-xl" data-id="element-34" />
        </div>
        <button className="px-10 py-5 bg-white text-[#C17A47] text-xl font-bold rounded-md hover:bg-[#F9F4EE] transition-all shadow-lg" data-id="element-35">
          QUIERO MIS 20 CENAS EXPRESS
        </button>
        <p className="text-white mt-6 opacity-90" data-id="element-36">
          Descarga instantánea • Formato PDF • Acceso desde cualquier
          dispositivo
        </p>
      </div>
    </section>;
};
export default CallToAction;